import React, { memo } from 'react';
import { Box, Typography } from "@mui/material";
import { useTheme, styled } from "@mui/material/styles";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";

const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
});

const ModalforCheck = ({ title, content, cancelBtn, saveBtn, setOpenModal, setModalAction }) => {
  const theme = useTheme();

  const handleClose = () => {
    setModalAction(false)
    setOpenModal(false);
  };

  const handleSave = () => {
    setModalAction(true)
    setOpenModal(false);
  };

  return (
    <>
      <StyledBox sx={{ margin: '10px 0px 20px 0px' }}>
        {title &&
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
          >
            {title}
          </Typography>
        }
      </StyledBox>
      <StyledBox sx={{ margin: '15px 10px 25px 10px', textAlign: 'center' }}>
        {content &&
          <>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontFamily: theme.typography.fontFamily,
              }}
            >
              {content}
            </Typography>
          </>
        }
      </StyledBox>
      <StyledBox>
        {cancelBtn && <Box style={{ margin: '10px' }}>
          <OutlineButton width="135px" height="42px" onClick={handleClose}>
            {cancelBtn}
          </OutlineButton>
        </Box>}
        {saveBtn && <Box style={{ margin: '10px' }}>
          <SolidButton width="135px" height="42px" onClick={handleSave}>
            {saveBtn}
          </SolidButton>
        </Box>}
      </StyledBox>
    </>
  );
}

export default memo(ModalforCheck);